import React, { useLayoutEffect, useRef } from 'react'

import {
  formatAmountInputDisplay,
  getDisplayCaretForRawLength,
  isValidAmountInputRaw,
  parseAmountInput,
} from '../../utils/amountInputFormat'

export function AmountInput({
  value,
  onUserInput,
  placeholder = '0.0',
  className,
  id,
}: {
  value: string | number
  onUserInput: (input: string) => void
  placeholder?: string
  className?: string
  id?: string
}) {
  const inputRef = useRef<HTMLInputElement>(null)
  const pendingCaret = useRef<number | null>(null)
  const rawValue = String(value)
  const displayValue = formatAmountInputDisplay(rawValue)

  useLayoutEffect(() => {
    if (pendingCaret.current == null || !inputRef.current) return
    inputRef.current.setSelectionRange(pendingCaret.current, pendingCaret.current)
    pendingCaret.current = null
  }, [rawValue])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target
    const selectionStart = input.selectionStart ?? displayValue.length
    const rawPrefixLength = parseAmountInput(input.value.slice(0, selectionStart), rawValue).length
    const nextRaw = parseAmountInput(input.value, rawValue)

    if (nextRaw !== '' && !isValidAmountInputRaw(nextRaw)) return

    pendingCaret.current = getDisplayCaretForRawLength(formatAmountInputDisplay(nextRaw), rawPrefixLength)
    onUserInput(nextRaw)
  }

  return (
    <input
      ref={inputRef}
      id={id}
      value={displayValue}
      onChange={handleChange}
      inputMode="decimal"
      autoComplete="off"
      autoCorrect="off"
      type="text"
      pattern="^[0-9\s\u00A0\u202F\u2009.,]*$"
      placeholder={placeholder}
      spellCheck={false}
      className={className}
    />
  )
}
